import util from "@/libs/util.js"
import { AccountLogin, AccountLogout } from "@/api/sys/login"

export default {
  namespaced: true,
  actions: {
    //登录
    login({ dispatch }, { vm, username, password, uuid, verCode, route = { name: "index" } }) {
      AccountLogin({ username, password, uuid, verCode })
        .then(async res => {
          //整个系统依赖 uuid 和 token 这两个cookie进行校验和存储
          //uuid：用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
          //token：用户当前登录状态 建议在网络请求中携带 token
          //如有必要 token 需要定时更新，默认保存一天
          util.cookies.set("uuid", res.id)
          util.cookies.set("token", res.accessToken)
          await dispatch("d2admin/user/set", { name: res.name }, { root: true })
          //用户登录后从持久化数据加载一系列的设置
          await dispatch("load")
          //更新路由 尝试去获取 cookie 里保存的需要重定向的页面完整地址
          const path = util.cookies.get("redirect")
          //根据是否存有重定向页面判断如何重定向
          vm.$router.replace(path ? { path } : route)
          //删除 cookie 中保存的重定向页面
          util.cookies.remove("redirect")
        })
        .catch(err => {
          console.log("err: ", err)
        })
    },

    //加载用户的设置
    load({ commit, dispatch }) {
      return new Promise(async resolve => {
        // DB -> store 加载用户名
        await dispatch("d2admin/user/load", null, { root: true })
        // DB -> store 加载主题
        await dispatch("d2admin/theme/load", null, { root: true })
        // DB -> store 加载页面过渡效果设置
        await dispatch("d2admin/transition/load", null, { root: true })
        // DB -> store 加载侧边栏折叠状态
        await dispatch("d2admin/menu/asideCollapseLoad", null, { root: true })
        // DB -> store 加载全局尺寸
        await dispatch("d2admin/size/load", null, { root: true })
        resolve()
      })
    },

    //注销
    logout({ commit }, { vm, confirm = false }) {
      function logout() {
        AccountLogout(util.cookies.get("token")).then(async res => {
          util.cookies.remove("token")
          util.cookies.remove("uuid")
          vm.$router.push({ name: "login" })
        })
      }
      //判断是否需要确认
      if (confirm) {
        commit("d2admin/gray/set", true, { root: true })
        vm.$confirm("注销当前账户吗?  打开的标签页和用户设置将会被保存。", "确认操作", {
          confirmButtonText: "确定注销",
          cancelButtonText: "放弃",
          type: "warning"
        })
          .then(() => {
            commit("d2admin/gray/set", false, { root: true })
            logout()
            //注销后重置应用
            setTimeout(() => {
              location.reload()
            }, 1000)
          })
          .catch(() => {
            commit("d2admin/gray/set", false, { root: true })
            vm.$message("放弃注销用户")
          })
      } else {
        logout()
        setTimeout(() => {
          location.reload()
        }, 1000)
      }
    }
  }
}
